<template>
  <BaseChart
    height="300px"
    chart-height="200px"
    title="Evaluation"
    :chart-data="mergedChartData"
    subtitle="Current and previous period"
  >
    <template #widget-options>
      <slot name="widget-options"></slot>
    </template>
  </BaseChart>
</template>

<script>
import { yAxis } from '@/reusable/base-chart/chart-data'
import { commonPropertiesMixin } from './common-properties-mixin'
import { customChartData } from '@/reusable/base-chart/common-custom-chart-data'

const chartData = {
  ...customChartData,
  yAxis: yAxis({ tickPositions: [0, 2, 4, 6, 8, 10] })
}

export default {
  mixins: [commonPropertiesMixin('evaluation-ratings-current-previous-period', chartData)]
}
</script>
